module.exports = __webpack_public_path__ + "img/round-cached-24px.908c4933.svg";